import { persistor } from "lib/redux/root/rootStore";

export const clearAllUserSession = () => {
  persistor.pause();
  window.sessionStorage.clear();
  window.localStorage.clear();
};
